import { X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";

const SIZE_DATA = [
  { size: "XS",  bust: "33–34", waist: "25–26", hips: "35–36" },
  { size: "S",   bust: "35–36", waist: "27–28", hips: "37–38" },
  { size: "M",   bust: "37–38", waist: "29–30", hips: "39–40" },
  { size: "L",   bust: "39–41", waist: "31–33", hips: "41–43" },
  { size: "XL",  bust: "42–44", waist: "34–36", hips: "44–46" },
  { size: "2XL", bust: "45–47", waist: "37–39", hips: "47–49" },
  { size: "3XL", bust: "48–50", waist: "40–42", hips: "50–52" },
  { size: "4XL", bust: "51–54", waist: "43–46", hips: "53–56" },
  { size: "5XL", bust: "55–58", waist: "47–50", hips: "57–60" },
];

export default function SizeGuideModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="size-guide-modal"
        className="sm:max-w-lg bg-cream"
      >
        <DialogHeader>
          <DialogTitle className="font-serif text-xl text-plum">
            Size Guide
          </DialogTitle>
        </DialogHeader>

        <p className="text-sm text-plum-light mb-4">
          All measurements are in inches. Measure yourself and compare to find your best fit.
        </p>

        <ScrollArea className="max-h-[400px]">
          <table className="w-full text-sm" data-testid="size-guide-table">
            <thead>
              <tr className="border-b border-plum/10">
                <th className="text-left py-3 pr-4 font-semibold text-plum text-xs uppercase tracking-wider">Size</th>
                <th className="text-left py-3 pr-4 font-semibold text-plum text-xs uppercase tracking-wider">Bust</th>
                <th className="text-left py-3 pr-4 font-semibold text-plum text-xs uppercase tracking-wider">Waist</th>
                <th className="text-left py-3 font-semibold text-plum text-xs uppercase tracking-wider">Hips</th>
              </tr>
            </thead>
            <tbody>
              {SIZE_DATA.map((row) => (
                <tr key={row.size} className="border-b border-plum/5 last:border-0">
                  <td className="py-3 pr-4 font-semibold text-plum">{row.size}</td>
                  <td className="py-3 pr-4 text-plum-light">{row.bust}"</td>
                  <td className="py-3 pr-4 text-plum-light">{row.waist}"</td>
                  <td className="py-3 text-plum-light">{row.hips}"</td>
                </tr>
              ))}
            </tbody>
          </table>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
